import React, { FC } from 'react';
import clsx from 'clsx';

import { CLinkPropsGraphQL } from '../../models/Contentful/types/siteTemplateGraphQL';
import LinkGraphQL from '../LinkGraphQL';
import styles from './socialLink.module.sass';

export interface SocialLinkProps {
  item?: CLinkPropsGraphQL;
  isSocialLink?: boolean;
  classes?: string;
  children?: React.ReactNode;
}

const SocialLink: FC<SocialLinkProps> = ({ item, ...props }) => {
  const { classes = '', isSocialLink = true, children } = props;
  const bodyCls = clsx(
    isSocialLink ? 'is-flex is-align-items-center ' : '',
    styles.socialLink,
    classes,
  );
  return (
    <div className={`${bodyCls}`}>
      <LinkGraphQL {...(item as CLinkPropsGraphQL)} showLabel={false}>
        {children}
      </LinkGraphQL>
      {!item && children}
    </div>
  );
};

export default SocialLink;
